<style>
  #MainDivCat *{
    font-weight: bolder;
    font-size: 14px;
    list-style: none;
  }
</style>

<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">ISO/IEC 17025 Tags</h5>

      <div id="MainDivCat">
        <ul>
          <li class="MyMoeinListCat_Li">

            <div class="MyMoeinListCat_Div">
              <span class="MyMoeinListCat_Span">Root</span>
              <i class="fa  fa-plus-circle MyMoeinListCat_Add" (click)="On_Add_Root(templateAdd)"></i>
            </div>

            <app-Protocol17025Cat_Co
              (On_Add_Action)="OnGet_Add_Action(templateAdd,$event)"
              (On_Edit_Action)="OnGet_Edit_Action(templateEdit,$event)"
              (On_Remove_Action)="OnGet_Remove_Action(templateDelete,$event)"
              [inner_17025_Cat]="DataList_Protocol17025Cat">

            </app-Protocol17025Cat_Co>

          </li>
        </ul>
      </div>

    </div>
  </div>
</div>


<ng-template #templateEdit>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Edit Tag</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Edit.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1"> Title </label>
        <input [(ngModel)]="Selected_Protocol17025Cat.title" name="title_edit" type="text" class="form-control"
          placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-success" (click)="Edit()"> Edit <i class="fa fa-edit"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Edit.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateAdd>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Add Tag</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Add.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1"> Title </label>
        <input [(ngModel)]="Add_Tag_Title" name="title_add" type="text" class="form-control"
          placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-success" [hidden]="Selected_Protocol17025Cat.id==0" (click)="Add(1)"> Add at Same Level <i class="fa fa-plus"></i></button>
    <button type="button" class="btn btn-info" (click)="Add(0)"> Add at Child Level  <i class="fa fa-plus"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Add.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateDelete>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Tag</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>

  <div class="modal-footer">

    <button type="button" class="btn btn-success" (click)="Delete(1)"> Delete and Move Children Up <i class="fa fa-remove"></i></button>
    <button type="button" class="btn btn-info" (click)="Delete(0)"> Delete with Children  <i class="fa fa-remove"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>
